



















import {Vue, Component, Prop} from 'vue-property-decorator';
import TicketService from "../../services/TicketService";
import WipTicket from "../../domainObjects/wip/WipTicket";
import Discrepancy from "../../domainObjects/wip/Discrepancy";
import SearchWip from "@/domainObjects/wip/SearchWip";

@Component({
})

export default class DiscrepancyPicker extends Vue {
    @Prop({required: false}) data!: WipTicket;
    @Prop({required: false}) selectMultiple!: Boolean;
    @Prop({required: false}) search!: SearchWip;

    private discrepancies: Discrepancy[] = [];
    private selectedDiscrepancy = {} as Discrepancy;

    mounted() {
        TicketService.getDiscrepancies().then((response) => {
            for( let discrepancy of response.data ) {
                let mappedDiscrepancies:Discrepancy = {id: discrepancy.id, desc: discrepancy.desc, value: discrepancy.id, text: discrepancy.desc };
                this.discrepancies.push(mappedDiscrepancies);
            }
            if (this.data && this.data.discrepancy && this.data.discrepancy.id){
                let i = this.discrepancies.findIndex(discrepancy => discrepancy.value === this.data.discrepancy.id);
                this.selectedDiscrepancy = this.discrepancies[i];
            }
        }).catch((error)=>{

        });
    }
    selectDiscrepancy(event){
        let value = this.discrepancies.filter(discrepancy => discrepancy.id == event.target.value);
        this.$emit('selectDiscrepancy', value[0])
    }
}
